import { useEffect } from 'react';
import { Dispatch } from 'redux';
import { toastMessage } from 'Containers/Toast/actions';
import { dateIsBefore } from 'Utils/dates';

/**
 * Show IWC data warning message if fromDate is earlier than Jan 1, 2021
 * @param dispatch
 * @param fromDate - fromDate selected from dropdown to filter Data.
 * @param enabled - whether to enable this warning message if fromDate condition matches.
 */
const useIwcDataWarning = (
  dispatch: Dispatch,
  fromDate: string,
  enabled: boolean = true
) => {
  useEffect(() => {
    if (enabled && dateIsBefore(fromDate, '2021-01-01')) {
      dispatch(
        toastMessage({
          message:
            'IWC performance data is available beginning in January 1, 2021.',
          position: 'bottom',
          duration: 10,
        })
      );
    }
  }, [dispatch, enabled, fromDate]);
};

export default useIwcDataWarning;
try {
    // @ts-ignore
    useIwcDataWarning.displayName = "useIwcDataWarning";
    // @ts-ignore
    useIwcDataWarning.__docgenInfo = { "description": "Show IWC data warning message if fromDate is earlier than Jan 1, 2021", "displayName": "useIwcDataWarning", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/utilities/useIwcDataWarning.ts#useIwcDataWarning"] = { docgenInfo: useIwcDataWarning.__docgenInfo, name: "useIwcDataWarning", path: "src/shared/containers/GoodData/utilities/useIwcDataWarning.ts#useIwcDataWarning" };
}
catch (__react_docgen_typescript_loader_error) { }